import bullent from '../../assets/images/bullent.png';
import { gtmEventHandler } from '../../utils/gtmDataLayer';

export default function SuggestArtical() {
  const handleBeforeNavigate = (url) => {
    gtmEventHandler({'event':'article_click',
        'category':url})
    console.log("Navigating to:", url); // You can replace this with any function you want
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <div className="md:p-6 p-2 md:px-[20%] font-fraunces flex-wrap flex justify-around items-center bg-[#F5F5F5] w-full">
      <div className="lg:max-w-[40%] flex justify-center flex-col items-center w-full my-2 md:my-0">
        <h1 className="md:text-[28px] text-[18px] font-fraunces font-[600] text-[#832729]">
          Suggested Articles
        </h1>
        <p className="font-[400] text-[15px] whitespace-nowrap text-left">
          Read more help and support articles, blogs here
        </p>
      </div>
      <div>
        {[
          {
            url: "https://blog.tanishq.co.in/stories-from-tanishq-exchange-a-journey-of-trust-loyalty-and-cherished-memories/",
            text: "Stories from Tanishq Exchange: A Journey of Trust, Loyalty, and Cherished Memories",
          },
          {
            url: "https://blog.tanishq.co.in/the-heart-of-rivaah-what-tanishqs-wedding-brand-stands-for/",
            text: "The Heart of Rivaah: What Tanishq’s wedding brand stands for",
          },
          {
            url: "https://blog.tanishq.co.in/mixing-and-matching-earring-styles-for-every-occasion/",
            text: "Mixing and Matching Earring Styles for Every Occasion",
          },
        ].map((article, index) => (
          <div key={index} className="flex justify-start items-start my-2">
            <img src={bullent} alt="" className="mr-2 max-w-[8px] mt-[2px]" />
            <p
              className="underline text-[15px] font-[400] cursor-pointer"
              onClick={() => handleBeforeNavigate(article.url)}
            >
              {article.text}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
